import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import { Alert, Typography } from 'antd';
import ChangedLifeCycleAlert from '../ChangedLifeCycleAlert';
import { lifeCycleEntitiesMap } from '../../constants';
import { contextNames, contexts } from '../../services/propsProvider';
import { useToHousingStockFn } from '../../../../services/toHousingStockFn';
import { useModalMethods } from '../../../../shared/packages/modalManager';
import { searchParamKeys } from '../../../../shared/configs/searchParams';

const Body = ({ canChange, changedLifeCycleData, children }) => {
  if (canChange) {
    return (
      <CanChangeBody changedLifeCycleData={changedLifeCycleData}>
        {children}
      </CanChangeBody>
    );
  }

  return (
    <CanNotChangeBody
      changedStageData={changedLifeCycleData?.find(findChangedStageItem)}
    />
  );
};

export default Body;

function CanChangeBody({ changedLifeCycleData, children }) {
  if (changedLifeCycleData != null) {
    return <ChangedLifeCycleAlert entities={changedLifeCycleData} />;
  }

  return children;
}

const descriptionLabels = {
  [lifeCycleEntitiesMap.stage]: 'стадию',
  [lifeCycleEntitiesMap.step]: 'этап',
  [lifeCycleEntitiesMap.acceptanceStatus]: 'результат приемки',
};

function CanNotChangeBody({ changedStageData }) {
  const name = useContext(contexts[contextNames.modalName]);

  const entity = useContext(contexts[contextNames.entity]);

  const { getProps } = useModalMethods();

  const toFn = useToHousingStockFn({
    linksCreator: getLinksCreator({ room: getProps(name)?.room }),
  });

  const description = (
    <Typography>
      {Boolean(changedStageData) && (
        <Typography.Paragraph>
          Стадия помещения была изменена на {changedStageData.actual}.
        </Typography.Paragraph>
      )}

      <Typography.Paragraph>
        В модуле «Приемки» допускается изменять {descriptionLabels[entity]}{' '}
        только, если помещение находится в стадии{' '}
        <Typography.Text strong>Приемка</Typography.Text>{' '}
      </Typography.Paragraph>
      {toFn && <Link to={toFn}>Перейти в жилой фонд</Link>}
    </Typography>
  );

  return (
    <Alert
      type="info"
      message="Изменять можно в Жилом фонде"
      description={description}
    />
  );
}

function findChangedStageItem(item) {
  return item.type === lifeCycleEntitiesMap.stage;
}

function getLinksCreator({ room }) {
  return (location) => {
    const params = new URLSearchParams(location.search);

    const companyId = params.get(searchParamKeys.company);

    return {
      pathname: `/HousingStock/company/${companyId}/houses/${room?.houseId}/flats/${room?.id}`,
      from: `Acceptance${location.search}`,
    };
  };
}
